import { Outlet } from 'react-router-dom';

import { SlideCheckout } from '#client/components/GlobalComponents/SlideCheckout';

function GlobalComponents({ children }) {
  return (
    <>
      <SlideCheckout />
      {children || <Outlet />}
    </>
  );
}

export default GlobalComponents;
